export function getUUID() {
  // May not be available in development
  return crypto.randomUUID?.() ?? `non-secure-id-${Math.random()}`;
}
